<template>
    <div :class="cn('flex flex-col-reverse sm:flex-row sm:justify-end gap-2', props.class)">
        <slot />
    </div>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{ class?: HTMLAttributes["class"] }>();
</script>
